import * as Yup from "yup";
import dayjs from "dayjs";

import {
    validationSchema as adjustmentValidationSchema,
    validationRowSchema as adjustmentValidationRowSchema,
    initialValues as adjustmentInitialValues,
    initialRowValues as adjustmentInitialRowValues
} from "./adjustmentSchema";

export const validationRowSchema = Yup.object().shape({
    itemId: Yup
        .string(),
    // .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    uomId: Yup
        .string()
        .required("Required"),
    inventoryBatchId: Yup
        .string()
        .required("Required"),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0
        let skipStockPost = Boolean(val?.skipStockPost)

        let valueSchema;

        if (skipStockPost) {
            valueSchema = Yup
                .number("")
                .typeError("Invalid")
                // .min(parseFloat(minQty))
                // .max(parseFloat(maxQty), `Max : ${maxQty}`)
                .positive("More than 0")
                .required("Required")
        } else {
            valueSchema = Yup
                .number("")
                .typeError("Invalid")
                // .min(parseFloat(minQty))
                .max(parseFloat(maxQty), `Max : ${maxQty}`)
                .positive("More than 0")
                .required("Required")
        }

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
            skipStockPost: Yup.bool().typeError("Invalid")
        })


    }),
    price: Yup
        .number("")
        .positive("Invalid")
        .required("Required")
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    paymentId: Yup
        .string()
        .required("Required"),
    paymentTypeId: Yup
        .string()
        .required("Required"),
    userId: Yup
        .string()
        .required("Required"),
    shippingBranchId: Yup
        .string()
        .required("Required"),
    billingBranchId: Yup
        .string()
        .required("Required"),
    receiveAmount: Yup
        .number()
        .typeError("Invalid")
        .min(Yup.ref('totalamount'), "Must be more than Total Amount")
        .required("Required"),
    rows: Yup.array().of(validationRowSchema),

    adjustments: adjustmentValidationSchema
})

export const initialRowValues = {
    itemId: "",
    name: "",
    code: "",
    description: "",
    qty: {
        value: "",
        maxQty: 0,
        skipStockPost: true
    },
    uomName: "",
    uomId: "",
    price: "",
    subtotal: "0.00",
    inventoryBatchId: "",
    availableQty: 0,
    // inventoryBatches: []
}

export const initialValues = {
    locationId: "",
    locationName: "",
    documentDate: dayjs(),
    remark: "",

    // customerUserId: "",
    // customerDisplay: "",
    userId: "",
    username: "",

    shippingBranchId: "",
    shippingBranchName: "",
    billingBranchId: "",
    billingBranchName: "",

    paymentId: "",
    paymentName: "",
    paymentTypeId: "",
    paymentTypeName: "",
    paymentReference: "",

    rows: [initialRowValues],

    receiveAmount: "0.00",

    totalamount: "0.00",

    // adjustments: adjustmentInitialValues

}